import React from 'react';

const TermsList = () => (
  <dl tabIndex={0}>
    <dt>503B compounding facility</dt>
    <dd>
      An outsourcing facility at one geographic location or address that compounds sterile drugs, has elected to register as an outsourcing facility, and is regulated under the section 503B of the Food, Drug, and Cosmetic Act of the Food and Drug Administration
    </dd>
    <dt>Ampule</dt>
    <dd>
      A hermetically sealed container, usually made of glass, containing sterile medical solution, or powder to be made up in solution, to be used for subcutaneous, intramuscular, or intravenous injection.
    </dd>
    <dt>Automated dispensing machine (ADM)</dt>
    <dd>
      A computerized drug-storage device or cabinet that allows medications to be stored and dispensed near the point of care while controlling and tracking drug distribution. Examples include Pyxis®, Omnicell®, and AcuDose-Rx®.
    </dd>
    <dt>Automated dispensing machine for anesthesia use (A-ADM)</dt>
    <dd>
      An automated dispensing machine specifically designed for use in an anesthesia setting that allows the following: all drawers to remain open, removal and debiting, documentation of doses administered, summary of doses given, and  documentation of waste.
    </dd>
    <dt>Barcode scanning of medications</dt>
    <dd>
      An inventory control system that uses barcodes to prevent human errors in the distribution and administration of medications. The information in barcodes allows for  comparison of the medication being administered with that ordered for the patient.
    </dd>
    <dt>Computerized provider order entry (CPOE)</dt>
    <dd>
      The process of a medical professional entering medication orders electronically.
    </dd>
    <dt>Elastomeric pumps</dt>
    <dd>
      Non-electronic external medication pumps that provide infusion therapy to a patient with an elastomeric balloon that consistently deflates and pushes medication solution through intravenous tubing. Examples include ON-Q™ and ACTion™ Block Pain Pump.
    </dd>
    <dt>Epidural solutions</dt>
    <dd>
      Anesthetic medication solutions administered via injection into the lumbar area of the spine between the spinal cord and the dura.
    </dd>
    <dt>Irrigation solutions</dt>
    <dd>
      Sterile medicated or unmedicated solutions used during operative or invasive procedures to cleanse the wound bed prior to closure.
    </dd>
    <dt>Joint Commission standards related to injectable medication preparation and ready to administer</dt>
    <dd>
      MM.05.01.07 The hospital safely prepares medications.
      <br />
      Element of Performance 1: A pharmacist, or pharmacy staff under the supervision of a pharmacist, compounds or admixes all compounded sterile preparations except in urgent situations in which a delay could harm the patient or when the product’s stability is short.
      <br />
      Element of Performance 2: Staff use clean or sterile techniques and maintain a clean, uncluttered, and functionally separate areas for product preparation to avoid contamination of medications.
      <br />
      Element of Performance 3: During preparation, staff visually inspect the medication for particulates, discoloration, or other loss of integrity.
      <br />
      Element of Performance 4: The hospital uses a laminar flow hood or other ISO Class 5 environment in the pharmacy for preparing intravenous (IV) admixture or any sterile product that will not be used in 24 hours.
      <br />
      MM.05.01.11 The hospital safely dispenses medications.
      <br />
      Element of Performance 4: Medications are dispensed in the most ready-to-administer forms commercially available and, if feasible, in unit doses that have been repackaged by the pharmacy or licensed repackager.
      <br />
      MM.03.01.03 The hospital safely manages emergency medications.
      <br />
      Element of Performance 3: Whenever possible, emergency medications are available in unit-dose, age-specific, and ready-to-administer forms.
    </dd>
    <dt>Multi-dose vial</dt>
    <dd>
      Vial of liquid medication intended for parenteral administration that contains more than one dose of medication and typically contains an antimicrobial preservative to help prevent the growth of bacteria.
    </dd>
    <dt>Patient-controlled analgesia (PCA) solution</dt>
    <dd>
      An analgesic medication solution whose administration is controlled by the patient.
    </dd>
    <dt>Prefilled syringe</dt>
    <dd>
      A disposable syringe that is supplied already containing the medication to be injected.
    </dd>
    <dt>Pre-mixed IV solution</dt>
    <dd>
      An intravenous (IV) solution that is supplied already containing the medication to be infused.
    </dd>
    <dt>Proprietary bag and vial systems</dt>
    <dd>
      Systems which link the drug and vial to allow, through a simple activation process, the two to be mixed and afford an extended stability than if the drug was actually mixed in the IV fluid. Examples include Mini-vial Plus™, ADD Vantage™, and Add-Ease™.
    </dd>
    <dt>Ready-to-administer medications</dt>
    <dd>
      Sterile medicines intended for administration by bolus injection, perfusion, or infusion by any of the following routes: intravenous, intramuscular, intrathecal, intra-arterial, subcutaneous, intradermal, intraventricular, epidural, intravesicular, intravitreal, intrapleural, and intraocular.
      <br />
      An injectable medicine is ready to administer when it requires no further dilution or reconstitution and is presented in the final container or device, ready for administration or connection to a needle or administration set.
      <br />
      This definition is from the World Health Organization (WHO).
    </dd>
    <dt>Smart infusion pump</dt>
    <dd>
       A medication infusion pump with software allowing for the creation of a medication library and providing medication dosing guidelines and dose limits as well as clinical advisories.
    </dd>
    <dt>USP &lt;797&gt; for immediate-use compounded sterile preparation (CSP) enforced on survey by the Centers for Medicare & Medicaid Services (CMS)</dt>
    <dd>
       Preparation of an immediate-use CSP must involve only simple transfer of no more than three commercially manufactured sterile nonhazardous products from the manufacturer’s original containers and no more than two entries into any one container or package of sterile infusion solution or administration container/device. Administration must begin no later than one hour after the start of the preparation of the CSP. If not, the CSP must be appropriately discarded.
    </dd>
  </dl>
);

export default TermsList;



// WEBPACK FOOTER //
// ./src/components/features/assessment/TermsList.js